import {Stack, Typography, TextField, Button, useMediaQuery} from "@mui/material";
import {useContext, useState, useCallback, FormEvent} from "react";
import {AuthContext} from "../../context/auth.context";
import {ValueWithOnchange} from "../../types";
import {LoginFooter} from "../footer";
import {validateEmail} from "../../utils/email";
import {Registered} from "./registered";

export const LoginForm = ({
                            value,
                            twoFA,
                            error: propsError,
                            onRegister,
                            onChange,
                            onSecretCodeChange,
                            onSubmit
                          }: ValueWithOnchange<string> & { error?: string}) => {
  const {check} = useContext(AuthContext);
  const [resend, setResend] = useState(false);
  const [error, setError] = useState('');
  const isMobile = useMediaQuery('(max-width:500px)');

  const [sent, setSent] = useState(false);

  const handleSubmit = useCallback((e: FormEvent) => {
    e.preventDefault();

    check(value).then(resp => {
      if (resp.status === "active") {
        if (resp.auth_url) {
          window.location.href = resp.auth_url;
        } else {
          onSubmit?.();
        }
      }

      onSecretCodeChange(resp.two_fa_enabled ? "true" : undefined)

      if (resp.status === "blocked") {
        setError('Ваш аккаунт заблокирован! Обратитесь к администратору!');
      } else if (resp.status === "not_confirmed") {
        // setResend(true);
        setError('Ваш аккаунт не подтвержден! Подтвердите свой аккаунт, перейдя по ссылке из письма!');
      } else if (resp.status === "suspended") {
        setError('Ваш аккаунт отключен! Обратитесь к администратору!');
      } else if (resp.status === "awaiting_manual_check") {
        setError('Ожидаем подтверждения учетной записи оператором.');
      }

      if (resp.can_register === false) {
        setError('Данный пользователь не заведен в системе. Регистрация возможна только через корпоративные службы. Обратитесь к администратору.');
      }

      if (resp.can_register || resp.status === 'invited') {
        onRegister?.();
      }
    })
  }, [check, onRegister, onSubmit, value, twoFA]);

  const handleResend = () => {
    setSent(true);
  }

  if (sent) {
    return <Registered/>
  }

  return (
      <form onSubmit={handleSubmit}>
        <Stack maxWidth={isMobile ? "100%" : "816px"} padding={isMobile ? "1rem" : "3rem"} alignItems="center" spacing={4} sx={{ width: "100%", boxSizing: "border-box" }}>
          <Typography variant="h1">Вход в систему</Typography>
          <Typography>Чтобы начать, введите свой адрес электронной почты</Typography>

          <Stack width={isMobile ? "100%" : "454px"} sx={{ maxWidth: "100%" }}>
            <TextField
                fullWidth
                autoFocus
                error={!!error || !!propsError || (!!value && !validateEmail(value) && value !== 'admin')}
                helperText={error ?? propsError ?? undefined}
                slotProps={{
                  input: {
                    autoComplete: 'new-password',
                  }
                }}
                label="Адрес электронной почты"
                value={value}
                onChange={e => {
                  setResend(false);
                  onChange(e.currentTarget.value)
                }}
            />
          </Stack>

          {resend && false && (
              <Button size="large" disabled={!value || (!validateEmail(value) && value !== 'admin')}
                      type="button" onClick={() => handleResend()}>Отправить письмо еще раз</Button>
          )}

          <Button size="large" disabled={!value || (!validateEmail(value) && value !== 'admin')}
                  type="submit">Войти</Button>

          <LoginFooter/>
        </Stack>
      </form>
  )
}
